<div>
    <app-tool-bar [title]="'Manage Clients'" (handleAdd)="displayAddModal = true" [iconName]="'pi-users'"
        [selectedProducts]="selectedProducts" [isBulkAction]="true" [isFilter]="false" [isAdd]="true"></app-tool-bar>
</div>

<div class="p-4 overflow-auto h-[85vh]">

    <p-table [value]="clientsData" [rows]="rows" [lazy]="true" (onLazyLoad)="loadClients($event)" [paginator]="true"
        [rowsPerPageOptions]="[10, 20, 50]" [totalRecords]="totalRecords" [loading]="loading"
        [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

        <ng-template pTemplate="header">
            <tr>
                <th>S.No</th>
                <th>Client Name</th>
                <th>City</th>
                <th>State</th>
                <th>Country</th>
                <th>Status</th>
                <th>Created At</th>
                <th>Action</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-campus let-i="rowIndex">
            <tr>
                <td>{{ i + 1 }}</td>
                <td>{{ campus.name || 'N/A' }}</td>
                <td>{{ campus.city_id || 'N/A' }}</td>
                <td>{{ campus.state_id || 'N/A' }}</td>
                <td>{{ campus.country_id || 'N/A' }}</td>
                <td>
                    <p-chip [label]="(campus.status || 'N/A') | titlecase"
                        [styleClass]="campus.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'">
                    </p-chip>
                </td>

                <td>{{ campus.createdAt | date: 'medium' }}</td>
                <td>
                    <div (click)="setClientData(campus)">
                        <p-menu [tabindex]="undefined" #menu [model]="clientActionItems" [popup]="true"
                            appendTo="body"></p-menu>
                        <i (click)="menu.toggle($event)" class="pi pi-ellipsis-h action-button cursor-pointer"></i>
                    </div>
                </td>
            </tr>
        </ng-template>


        <ng-template pTemplate="loading">
            <tr>
                <td colspan="8" class="text-center">
                    <p-progressSpinner></p-progressSpinner>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="8" class="no-data-record-found">
                    <p>No records found</p>
                </td>
            </tr>
        </ng-template>
    </p-table>

</div>

<ng-container *ngIf="displayAddModal">
    <p-dialog [(visible)]="displayAddModal" [modal]="true" [style]="{width: '70rem'}" [closable]="false">
        <app-add-client (reload)="reloadClients()" (close)="displayAddModal = false"></app-add-client>
    </p-dialog>
</ng-container>


<ng-container *ngIf="showDeleteClient">
    <p-dialog [(visible)]="showDeleteClient" [modal]="true" [style]="{width: '40rem'}" [closable]="false">
        <app-delete-client 
        [clientDataToEdit]="clientDataToEdit"
        (reload)="reloadClients()" (close)="showDeleteClient = false"></app-delete-client>
    </p-dialog>
</ng-container>